export default "__VITE_ASSET__DIPe6gWU__"